import type { FaireProductEntity } from "../../entity_types/product";

export const p_3d86pb9zxf: FaireProductEntity = {
  token: "p_3d86pb9zxf",
  type: "product",
  name: "Evil Eye Pointed Bling Hamsa Hand Tassel Keychain",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/b0b0da5dd1430662ffa7773def09200f6ea545683688c1eeb1dd3975b687d5d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e552ab01ba0ee5d6db1c448d7fb2988dd9b14d4707420630c79615fb03acb3d.jpeg",
  ],
  priceDollars: 4.96,
  description:
    'Size : 2" X 2.75", 6.5" L\nLead and Nickel Compliant\nSymbolic hand charm keychain designed to add meaning and style to keys, bags, or accessories. Featuring a detailed hand silhouette with an eye motif, decorative accents, and a tassel, this keychain is ideal for gifting or everyday use. A fashionable accessory that represents protection, positivity, and personal expression while adding eye-catching detail to any carry.\n',
  tags: [],
  msrpDollars: 9.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:41.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
